export interface Module {
  title: string
  body: string
  tagline: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
  /** Module mis en avant sur la page */
  featured?: boolean
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — FONDAMENTAUX DE L’ÉLECTROCARDIOGRAPHIE ET ANATOMIE ÉLECTRIQUE DU CŒUR',
    body: 'Le système de conduction, du nœud sinusal au réseau de Purkinje ; les 12 dérivations comme 12 points de vue sur le cœur ; la pose des électrodes ; les ondes P, QRS et T, les intervalles, le papier millimétré, l’étalonnage et la galerie des artefacts.',
    tagline: 'Comprendre d’où vient chaque onde.',
    color: 'rgb(var(--color-module-1))',
  },
  {
    title: 'MODULE 2 — LECTURE SYSTÉMATIQUE ET INTERPRÉTATION DES TRACÉS ECG',
    body: 'Le cœur du système. La méthode FRÉQUENCE › RYTHME › AXE › INTERVALLES › ST-T appliquée pas à pas : calcul de la fréquence, régularité des RR, critères du rythme sinusal, axe par DI et aVF, mesure du PR, du QRS et du QT, analyse du segment ST et de l’onde T. Chaque étape a sa planche « normal / anormal » annotée, avec grille de lecture et fiches de mesure.',
    tagline: 'Lire chaque tracé dans le même ordre, sans rien oublier.',
    color: 'rgb(var(--color-module-2))',
    featured: true,
  },
  {
    title: 'MODULE 3 — ARYTHMIES CARDIAQUES ET TROUBLES DE LA CONDUCTION',
    body: 'Tachycardies à QRS fins et à QRS larges, fibrillation atriale, flutter, TSV, TV, bradycardies, extrasystoles, blocs atrioventriculaires et blocs de branche. Une fiche par rythme : critères, tracé pédagogique annoté, piège fréquent et conduite infirmière.',
    tagline: 'Reconnaître le rythme et le niveau d’urgence.',
    color: 'rgb(var(--color-module-3))',
  },
  {
    title: 'MODULE 4 — ISCHÉMIE MYOCARDIQUE, INFARCTUS ET ANOMALIES ECG',
    body: 'Sus-décalage et sous-décalage du ST, onde T, ondes Q, image en miroir, correspondance dérivations / territoires, hypertrophies et signes évocateurs de troubles ioniques, avec la carte des territoires et des planches comparatives.',
    tagline: 'Repérer ce qui impose de transmettre sans délai.',
    color: 'rgb(var(--color-module-4))',
  },
  {
    title: 'MODULE 5 — SURVEILLANCE CARDIAQUE ET ECG EN PRATIQUE CLINIQUE',
    body: 'Scope et télémétrie, dérivation de surveillance, alarmes justifiées et fausses alarmes, réalisation de l’ECG au lit du patient, qualité du tracé, traçabilité et transmission structurée au format SAED. Le rôle infirmier : observer, noter, transmettre, alerter.',
    tagline: 'Surveiller avec méthode, transmettre avec clarté.',
    color: 'rgb(var(--color-module-5))',
  },
  {
    title: 'MODULE 6 — ATLAS DE CAS CLINIQUES ECG ET ENTRAÎNEMENT À L’INTERPRÉTATION',
    body: 'Cas pédagogiques progressifs sur 12 dérivations, du tracé normal aux situations urgentes : contexte, lecture guidée selon la méthode, éléments repérés, conduite infirmière et corrigé détaillé, avec autoévaluation de fin de module.',
    tagline: 'S’entraîner jusqu’à lire avec assurance.',
    color: 'rgb(var(--color-module-6))',
  },
]
